(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geeta-flash-sale"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-countdown"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();
})();
